import { useAppDispatch, useAppSelector } from "../../App/hooks";
import Button from "../../Components/Button";
import { useState, useEffect } from "react";
import TextInput from "../../Components/TextInput";
import { toast } from "react-toastify";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import CheckBox from "../../Components/Checkbox";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { IEditNLegOrderFormValues } from "../../Interfaces/nLegsInterfaces";
import { editNLegOrder } from "../../Requests/nLegsRequests";
import { StepOrderSide } from "../../Interfaces/stepInterfaces";
import {
  setNLegsEditFlag,
  setNLegsEditRowValues,
} from "../../Features/NLegs/nLegsSlice";
import { stringifyNumbers } from "../../helper";

const EditOrder = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const editOrderRowValues = useAppSelector(
    (store) => store.nLegs.editOrderRowValues
  );

  const [formValues, setFormValues] = useState<IEditNLegOrderFormValues>(
    {} as IEditNLegOrderFormValues
  );

  useEffect(() => {
    if (editOrderRowValues)
      setFormValues({
        applyToSimilar: false,
        maxPairPosition: editOrderRowValues.maxPairPosition,
        nLegOrderId: editOrderRowValues.id,
      });
  }, [editOrderRowValues]);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  // useEffect(() => {
  //   if (!formValues.applyToSimilar) changeHandler("stepOrderIds", null);
  // }, [formValues.applyToSimilar]);

  const onSendClick = () => {
    setLoading(true);
    editNLegOrder({
      ...formValues,
      maxPairPosition: formValues.maxPairPosition
        ?.toString()
        .replaceAll(",", "") as any,
    })
      .then((resp) => {
        toast.success(resp.msg);
        dispatch(setNLegsEditRowValues(null));
        dispatch(setNLegsEditFlag(false));
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const checkIsBtnDisabled = () => {
    if (!formValues.maxPairPosition) return true;
    return false;
  };

  const onCancelClick = () => {
    dispatch(setNLegsEditRowValues(null));
    dispatch(setNLegsEditFlag(false));
  };

  // const getTabBoxActiveTab = () => {
  //   if (formValues.applyToAll) return 2;
  //   return 1;
  // };

  if (!editOrderRowValues) return null;

  return (
    <div className="flex flex-col justify-start items-start gap-[6px] whitespace-nowrap text-xs ml-2 border-2 border-gray-300 rounded py-3 px-2 mt-6">
      {loading ? <FullScreenLoading /> : <></>}
      <div className="flex flex-col justify-start items-start gap-3 w-full">
        <div className="grid grid-cols-3 gap-2 text-xs font-bold w-full">
          <div className="flex flex-row justify-start items-center gap-2">
            <div>کاربر صحرا:</div>
            <div>{editOrderRowValues?.sahraName}</div>
          </div>
          <div />
          <div />
          <>
            {editOrderRowValues.instrumentInfo.map((info, i) => (
              <div className="flex flex-row justify-start items-center gap-2">
                <div>نماد {stringifyNumbers(i + 1)}:</div>
                <div
                  className={`${
                    info?.orderSide === StepOrderSide.Buy
                      ? "text-green-700"
                      : info?.orderSide === StepOrderSide.Sell
                      ? "text-red-700"
                      : "text-gray-600"
                  } `}
                >
                  {info?.instrumentName}
                </div>
              </div>
            ))}
          </>
          <>
            {editOrderRowValues.instrumentInfo.map((info, i) => (
              <div className="flex flex-row justify-start items-center gap-2">
                <div>جهت {stringifyNumbers(i + 1)}:</div>
                <div
                  className={`${
                    info?.orderSide === StepOrderSide.Buy
                      ? "text-green-700"
                      : info?.orderSide === StepOrderSide.Sell
                      ? "text-red-700"
                      : "text-gray-600"
                  } `}
                >
                  {info?.orderSide === StepOrderSide.Sell
                    ? "فروش"
                    : info?.orderSide === StepOrderSide.Buy
                    ? "خرید"
                    : "-"}
                </div>
              </div>
            ))}
          </>
        </div>

        <TextInput
          label="حداکثر بهای تمام شده"
          name="maxPairPosition"
          value={formValues.maxPairPosition?.toString()}
          onChange={changeHandler}
          classname="ltr !text-right"
          extraLabel
        />
        <CheckBox
          checked={formValues.applyToSimilar}
          name="applyToSimilar"
          label="همه سفارشهای مشابه"
          onChange={changeHandler}
        />
      </div>

      <div className="flex flex-row justify-between items-center w-full mt-2">
        <Button
          onClick={onCancelClick}
          text="لغو"
          variant="outlined"
          className="!w-16 !h-6 !text-xs"
        />
        <Button
          onClick={onSendClick}
          text="ارسال"
          variant="contained"
          className="!w-16 !h-6 !text-xs"
          disabled={checkIsBtnDisabled()}
        />
      </div>
    </div>
  );
};

export default EditOrder;
